import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Lottie from "lottie-react";

import successAnimation from "../assets/Success.json";
import failureAnimation from "../assets/failure.json";
import loadingAnimation from "../assets/Insider-loading.json"; // <- Add a loading animation JSON
import { getApiUrl } from "../utils/api";

const PaymentStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const merchantOrderID = query.get("merchantOrderID");

  const [status, setStatus] = useState("LOADING"); // <- Default is loading

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        const res = await fetch(getApiUrl("check-status"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ merchantOrderID }),
        });

        const data = await res.json();

        if (data.status === "SUCCESS") setStatus("SUCCESS");
        else if (data.status === "PENDING") setStatus("PENDING");
        else setStatus("FAILED");
      } catch (err) {
        console.error("Payment status error:", err);
        setStatus("FAILED");
      }
    };

    checkPaymentStatus();

    const timer = setTimeout(() => {
      navigate("/bsk-user");
    }, 3000); // Redirect after 3s

    return () => clearTimeout(timer);
  }, [merchantOrderID, navigate]);

  // Choose Lottie animation based on status
  const getAnimation = () => {
    if (status === "LOADING" || status === "PENDING") return loadingAnimation;
    return status === "SUCCESS" ? successAnimation : failureAnimation;
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ height: "80vh" }}
    >
      <Lottie
        animationData={getAnimation()}
        loop={status === "LOADING" || status === "PENDING"} // Loop only loading/pending
        style={{ width: 300, height: 300 }}
      />
      <h3 className="mt-3">
        {status === "SUCCESS"
          ? "Payment Successful!"
          : status === "PENDING"
          ? "Payment Pending..."
          : status === "FAILED"
          ? "Payment Failed!"
          : "Checking Payment..."} {/* Default for LOADING */}
      </h3>
      <p className="text-muted">Redirecting to your account...</p>
    </div>
  );
};

export default PaymentStatus;
